import Moment from 'moment';
import { Fetch } from './FetchApi';
import Config from '../Config';

export const GetUrl = (url) => {
  return url + '?v=' + new Date().getTime();
}

export const GetDefaultVideo = (config) => {
  // console.log('GetDefaultVideo', config);
  if (config && config.content && config.content.videos) {
    for (let i = 0; i < config.content.videos.length; i++) {
      if (config.content.defaultVideo === config.content.videos[i].id) {
        return config.content.videos[i];
      }
    }
  }
};

export const GetEvent = (config, id) => {
  console.log('GetEvent', config, id);
  if (config && config.eventPanel && config.eventPanel.events) {
    for (let i = 0; i < config.eventPanel.events.length; i++) {
      const event = config.eventPanel.events[i];
      if (event.id === id) {
        return event;
      }
    }
  }
};

const FetchUrl = async (url) => {
  //console.log('Fetch Url: ', url);
  const payload = {
    method: 'GET',
  }
  return await Fetch(url, payload);
};

export const FetchConfig = async (url) => {
  const config = await FetchUrl(url);
  if (config && config.eventPanel && config.eventPanel.events) {
    const promises = [];
    for (let i = 0; i < config.eventPanel.events.length; i++) {
      const event = config.eventPanel.events[i];
      if (event && event.contentUrl) {
        promises.push(FetchUrl(GetUrl(event.contentUrl)).then((content) => event.content = content));
      }
    }
    await Promise.all(promises);
  }
  return config;
}

export const UpdateConfig = (config) => {
  // console.log('UpdateConfig', config);
  if (config && config.eventPanel && config.eventPanel.events) {
    for (let i = 0; i < config.eventPanel.events.length; i++) {
      updateEvent(config.eventPanel.events[i]);
    }
  }
  return config;
}

const updateEvent = (event) => {
  // console.log('updateEvent', event);
  event.isLive = false;
  event.isReplay = false;
  event.isVoD = false;
  event.isUpcoming = false;
  event.isPending = false;
  event.isExpired = false;
  const publishDate = Moment(event.publishDate).valueOf();
  const startDate = Moment(event.startDate).valueOf();
  const endDate = Moment(event.endDate).valueOf();
  const expireDate = Moment(event.expireDate).valueOf();
  const now = new Date().getTime();
  if (now >= expireDate) {
    event.isExpired = true;
  }
  else if (now < publishDate) {
    event.isUpcoming = true;
  }
  else if (event.startDate && event.endDate && (startDate <= now) && (now < endDate)) {
    event.isLive = true;
  }
  else if (event.startDate && event.endDate && (endDate < now)) {
    event.isReplay = true;
  }
  else {
    event.isPending = true;
  }
}

export const validEmail = (email) => {
  if (!Config.DOMAIN_WHITELIST || Config.DOMAIN_WHITELIST.length === 0 || Config.DOMAIN_WHITELIST === '[]') {
    return true;
  }
  try {
    if (Config.DOMAIN_WHITELIST) {
      const whitelist = JSON.parse(Config.DOMAIN_WHITELIST);
      if (whitelist && whitelist.length > 0) {
        const split = email.split("@");
        if (split.length === 2) {
          const domain = split[1].toLowerCase();
          for (let i = 0; i < whitelist.length; i++) {
            if (domain === whitelist[i]) {
              return true;
            }
          }
        }
      }
    }
  }
  catch (e) {
    console.log(e);
  }
  return false;
};